import React, { useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./BrandsCarouselMobile.scss";
import { desktopImages } from "../../../../images";

const BrandsCarouselMobile = () => {
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleBrandClick = (e, url) => {
    e.preventDefault();
    const element = document.querySelector(url);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    arrows: false,
    centerMode: false,
    variableWidth: false,
    initialSlide: 0,
    rtl: false,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
    appendDots: dots => {
      const totalDots = 3;
      
      const customDots = Array.from({ length: totalDots }).map((_, i) => {
        let slideIndex, isActive;
        
        if (i === 0) {
          slideIndex = 0;
          isActive = currentSlide === 0;
        } else if (i === 1) {
          slideIndex = 1;
          isActive = currentSlide === 1;
        } else {
          slideIndex = 2;
          isActive = currentSlide >= 2;
        }
        
        return (
          <li
            key={i}
            className={isActive ? "slick-active" : ""}
            onClick={() => sliderRef.current?.slickGoTo(slideIndex)}
            style={{ cursor: 'pointer', display: 'inline-block', margin: '0 4px', visibility: 'visible' }}
          >
            <button
              style={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                background: isActive ? '#000' : '#666',
                border: 'none',
                padding: 0,
                opacity: 1
              }}
              aria-label={`Ir para o grupo ${i + 1}`}
            />
          </li>
        );
      });
      return (
        <div className="custom-dots">
          <button
            className="carousel-btn prev-btn"
            onClick={() => sliderRef.current?.slickPrev()}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <ul style={{ display: 'flex', alignItems: 'center', listStyle: 'none', padding: 0, margin: 0 }}>
            {customDots}
          </ul>
          <button
            className="carousel-btn next-btn"
            onClick={() => sliderRef.current?.slickNext()}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
      );
    }
  };

  const brands = [
    {
      logo: desktopImages.EssentiaPharmaDark,
      alt: "Essentia Pharma",
      url: "#pharma"
    },
    {
      logo: desktopImages.EssentialNutritionDark,
      alt: "Essential Nutrition",
      url: "#nutrition"
    },
    {
      logo: desktopImages.NoorskinDark,
      alt: "Noorskin",
      url: "#noorskin"
    },
    {
      logo: desktopImages.BeGenerousDark,
      alt: "Be Generous",
      url: "#be-generous"
    },
    {
      logo: desktopImages.TechnologiesDark,
      alt: "Essentia Technologies",
      url: "#technologies"
    }
  ];

  return (
    <div className="content-brands-carousel-mobile">
      <div className="brands-carousel-mobile">
        <div className="container">
          <h2 className="carousel-title-mobile">Conheça as empresas do grupo:</h2>
          <div className="carousel-wrapper">
            <Slider {...settings} ref={sliderRef}>
              {brands.map((brand, index) => (
                <div key={index} className="brand-slide">
                  <div className="brand-logo-container">
                    <a 
                      href={brand.url}
                      onClick={(e) => handleBrandClick(e, brand.url)}
                      className="brand-link"
                    >
                      <img
                        src={brand.logo}
                        alt={brand.alt}
                        className="brand-logo"
                      />
                    </a>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandsCarouselMobile;